import styled from '@emotion/styled';
import { Tabs as TabsAnt } from 'antd';

export const Tabs = styled(TabsAnt)`
  &.ant-tabs {
    .ant-tabs-nav {
      margin-bottom: 16px;
      .ant-tabs-nav-wrap {
        .ant-tabs-nav-list {
          height: 2.5rem;
          .ant-tabs-tab {
            padding: 8.2px 16px;

            .ant-tabs-tab-btn {
              font-weight: 500;
            }
          }
        }
      }
      .ant-tabs-tab + .ant-tabs-tab {
        margin-left: 4px;
      }
    }
  }
  &.factory-tabs {
    .ant-tabs-nav {
      margin-bottom: 0;
    }
  }
`;
